import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi'; 
import Logo from '../assets/images/logo.png';
import './Navbar.css';
import { FaHome, FaUser, FaBriefcase, FaEnvelope } from 'react-icons/fa';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="navbar-logo">
        <img src={Logo} alt="Logo" />
      </div>

      <button
        className="hamburger-icon"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Menú"
      >
        <FiMenu />
      </button>

      <nav className={`navbar-links-vertical ${menuOpen ? 'open' : ''}`}>
        <Link to="/" onClick={() => setMenuOpen(false)}>
          <FaHome style={{ marginRight: '8px' }} />
          Inicio
        </Link>
        <Link to="/sobre-mi" onClick={() => setMenuOpen(false)}>
          <FaUser style={{ marginRight: '8px' }} />
          Sobre Mí
        </Link>
        <Link to="/portfolio" onClick={() => setMenuOpen(false)}>
          <FaBriefcase style={{ marginRight: '8px' }} />
          Portfolio
        </Link>
        <Link to="/contacto" onClick={() => setMenuOpen(false)}>
          <FaEnvelope style={{ marginRight: '8px' }} />
          Contacto
        </Link>
      </nav>

    </header>
  );
}

export default Navbar;
